/**
 * react-select `filterOption` that matches every search token independently.
 *
 * The stock filter tests the typed string as one substring of the label, so it
 * only finds a matter when you type its words in the order they appear:
 * "sha div" misses "(999364) SHA DIVERSE - (11123) Moalem Weitemeyer …".
 *
 * This splits the input on whitespace and requires each token to appear
 * somewhere in the label, in any order — so "sha div", "div sha" and
 * "moalem diverse" all find that same matter.
 *
 * Usage:
 *   <Select options={...} filterOption={matchesAllTokens} />
 */
export function matchesAllTokens(option, rawInput) {
  const tokens = (rawInput || '').toLowerCase().split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return true;

  const label = String(option?.label ?? '').toLowerCase();
  return tokens.every(token => label.includes(token));
}
